import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useStyles } from "../../assets/jss/views/Auth";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomList from "../CustomComponents/CustomList/CustomList";
import CustomListItem from "../CustomComponents/CustomListItem/CustomListItem";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomTextField from "../CustomComponents/CustomTextField/CustomTextField";
import CustomButton from "../CustomComponents/CustomButton/CustomButton";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { getResetPassword } from "../../services/ResetPassword";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppGlobals, PasswordLength } from "../../config/app-globals.enum";

export default function ResetPassword(props) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const classes = useStyles();
  const [requestToken, setRequestToken] = useState("");
  const [requestEmail, setRequestEmail] = useState("");
  // const passwordValidation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,])[A-Za-z\d!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,]{8,255}$/;
  const passwordValidation = new RegExp(AppGlobals.PASSWORD_REGX);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [passwordResetSuccessfully, setPasswordResetSuccessfully] = useState<any>(
    {}
  );
  const [passwordCriteria, setPasswordCriteria] = useState([
    {
      type: "minLengthCase",
      message: i18n.t(`PASSWORD_PATTERN_LENGTH_TEXT`, {
        minLength: PasswordLength.MIN,
      }),
      regex: /^.{8,}/,
      isValid: null,
    },
    {
      type: "upperCase",
      message: t(`PASSWORD_PATTERN_UPPER_CASE_TEXT`),
      regex: /[A-Z]/,
      isValid: null,
    },
    {
      type: "lowerCase",
      message: t(`PASSWORD_PATTERN_LOWER_CASE_TEXT`),
      regex: /[a-z]/,
      isValid: null,
    },
    {
      type: "numberCase",
      message: t(`PASSWORD_PATTERN_NUMBER_TEXT`),
      regex: /\d/,
      isValid: null,
    },
    {
      type: "specialCharCase",
      message: i18n.t(`PASSWORD_PATTERN_SPECIAL_CHAR_TEXT`, {
        exSpecialChar: `@#$%!^*(),.?:{}|_-`,
      }),
      regex: /[@#$%!^&*(),.?":{}|<>_-\s]/,
      isValid: null,
    },
  ]);
  const [listOfErrors] = useState({
    emptyEmailError: t("PLEASE_ENTER_YOUR_EMAIL"),
    emptyPasswordError: t("NEW_PASSWORD_REQUIRED"),
    lengthPasswordError: i18n.t(
      "NEW_PASSWORD_MUST_BE_BETWEEN_GIVEN_CHARACTERS_IN_LENGTH",
      { minLength: PasswordLength.MIN }
    ),
    complexPasswordError: t(
      "PASSWORD_MUST_CONTAIN_MIXTURE_OF_UPPER_AND_LOWER_CASE_AND_NUMBERS"
    ),
    matchPasswordError: t("PASSWORDS_DO_NOT_MATCH"),
  });
  const [validationError, setValidationError] = useState({
    error: false,
    errorMessage: "",
  });

  // useEffect(() => {
  //   const queryParams = qs.parse(history.location.search);
  //   const _token = queryParams["token"];
  //   const _email = queryParams["?email"];
  //   setRequestToken(_token);
  //   if (_email) {
  //     setRequestEmail(_email);
  //   }
  // }, [history]);

  useEffect(() => {
    if (props.token && props.token.length) {
      setRequestToken(props.token);
    }
  }, [props.token]);
  useEffect(() => {
    if (props.email && props.email.length) {
      setEmail(props.email);
    }
  }, [props.email]);

  async function loadData(email, password, confirmPassword, requestToken) {
    setIsBtnDisabled(true)
    const data = await getResetPassword(
      email,
      requestToken,
      password,
      confirmPassword
    );
    setIsBtnDisabled(false)
    if (data && (data.status.code === 0 || data.status.code === 200)) {
      setPasswordResetSuccessfully({
        status: true,
        message: t("PASSWORDS_RESET_SUCCESSFULLY"),
      });
      setLoading(false);
      setTimeout(function () {
        history.push("/login");
      }, 1500);
    } else {
      setPasswordResetSuccessfully({
        status: false,
        message: data.status.message,
      });
      setLoading(false);
      if (data.status.code === 401) {
        setTimeout(() => {
          history.replace("/login");
        }, 500);
      }
    }
  }

  const handleFormSubmit = () => {
    setLoading(true);
    setPasswordResetSuccessfully({});
    setValidationError({ error: false, errorMessage: "" });
    props.resetKeyDown(false);

    if (email.length === 0) {
      setValidationError({
        error: true,
        errorMessage: listOfErrors.emptyEmailError,
      });
      setIsBtnDisabled(true)
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      setValidationError({
        error: true,
        errorMessage: listOfErrors.matchPasswordError,
      });
      setIsBtnDisabled(true)
      setLoading(false);
      return;
    }
    if (password.length === 0 || confirmPassword.length === 0) {
      setValidationError({
        error: true,
        errorMessage: listOfErrors.emptyPasswordError,
      });
      setIsBtnDisabled(true)
      setLoading(false);
      return;
    }
    // if (
    //   password.length < PasswordLength.MIN ||
    //   confirmPassword.length < PasswordLength.MIN
    // ) {
    //   setValidationError({
    //     error: true,
    //     errorMessage: listOfErrors.lengthPasswordError,
    //   });
    //   setLoading(false);
    //   return;
    // }
    if (!passwordValidation.test(password)) {
      setValidationError({
        error: true,
        errorMessage: listOfErrors.complexPasswordError,
      });
      setIsBtnDisabled(true)
      setLoading(false);
      return;
    }
    if (!validationError.error) {
      setLoading(false);
      loadData(email.trim(), password, confirmPassword, requestToken);
    }
  };

  useEffect(() => {
    if (props.handleKeyDown) {
      handleFormSubmit();
    }
  }, [props.handleKeyDown]);

  useEffect(() => {
    if (email && email.length && password && password.length && confirmPassword && confirmPassword.length) {
      if (passwordCriteria.find((item) => item.isValid === false || item.isValid === null)) {
        setIsBtnDisabled(true)
      } else {
        setIsBtnDisabled(false)
      }

    } else {
      setIsBtnDisabled(true)
    }
  }, [email, password, confirmPassword, passwordCriteria]);

  const [passwordStatus, setPasswordStatus] = useState(false);
  useEffect(() => {
    if (password || passwordStatus) {
      setPasswordStatus(true);
      if (
        passwordCriteria &&
        passwordCriteria.length
      ) {
        const _passwordCriteria = [];
        passwordCriteria.forEach((item) => {
          const _item = { ...item };
          if (_item.regex.test(password)) {
            _item.isValid = true;
          } else {
            _item.isValid = false;
          }
          _passwordCriteria.push({ ..._item });
        });
        setPasswordCriteria([..._passwordCriteria]);
      }
    }

  }, [password]);

  useEffect(() => {
    if (confirmPassword.length && password.length) {
      if (password === confirmPassword) {
        setValidationError({ error: false, errorMessage: "" });
      } else {
        setValidationError({ error: true, errorMessage: "" });
      }
    }
  }, [password, confirmPassword]);

  return (
    <form>
      <CustomBox className={classes.boxWrapper}>
        <CustomBox
          className={clsx(classes.titleWrap, classes.titleWrapForgotten)}
        >
          <CustomTypography
            component="h1"
            variant="h5"
            className={classes.title}
          >
            {t("SET_YOUR_NEW_PASSWORD")}
          </CustomTypography>
          {passwordResetSuccessfully.status === true && (
            <CustomTypography component="p" className={classes.successMessage}>
              {passwordResetSuccessfully.message}
            </CustomTypography>
          )}
          {passwordResetSuccessfully.status === false && (
            <CustomTypography
              component="p"
              className={clsx(
                classes.errorMessage,
                classes.errorMessageForgotten
              )}
            >
              {passwordResetSuccessfully.message}
            </CustomTypography>
          )}
          {validationError.error && (
            <CustomTypography
              component="p"
              className={clsx(
                classes.errorMessage,
                classes.errorMessageForgotten
              )}
            >
              {validationError.errorMessage}
            </CustomTypography>
          )}
        </CustomBox>
        <CustomBox my={4}>
          <CustomTextField
            className={classes.input}
            label={t("EMAIL")}
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{ disableUnderline: true }}
          />
        </CustomBox>
        <CustomBox my={4}>
          <CustomTextField
            className={classes.input}
            label={t("PASSWORD")}
            type="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{ disableUnderline: true }}
          />
          <CustomBox className={classes.helperTextWrapper}>
            <CustomBox className={classes.helperTextLabel}>
              {t(`PASSWORD_PATTERN_LABEL`)}
            </CustomBox>
            {passwordCriteria && passwordCriteria.length ? (
              <CustomList className={classes.helperTextList} dense={true}>
                {passwordCriteria.map((criteria) => (
                  <CustomListItem
                    text="primary"
                    key={criteria.type}
                    className={clsx(
                      classes.helperTextListItem,
                      criteria.isValid === true
                        ? classes.isValid
                        : criteria.isValid === false
                          ? classes.isInvalid
                          : null
                    )}
                  >
                    {criteria.message}
                  </CustomListItem>
                ))}
              </CustomList>
            ) : null}
          </CustomBox>
        </CustomBox>
        <CustomBox my={4}>
          <CustomTextField
            className={classes.input}
            label={t("CONFIRM_PASSWORD")}
            type="password"
            name="confirmpassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{ disableUnderline: true }}
          />
        </CustomBox>
        <CustomBox mt={4} mb={3}>
          <CustomButton
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleFormSubmit}
            disabled={isBtnDisabled}
          >
            {t("SUBMIT")}
            {loading && (
              <CustomCircularProgress
                color="inherit"
                style={{ marginLeft: "15px" }}
                size={15}
              />
            )}
          </CustomButton>
        </CustomBox>
      </CustomBox>
    </form>
  );
}
